/**
 * The onboarding-wizard session token is short-lived and transient — it lives
 * only in `sessionStorage` (cleared when the tab closes), never in the persisted
 * portal-session store. It authorizes the field-autosave / submit calls for a
 * single fill-request link; the token itself is not sensitive PII but is treated
 * as a bearer credential, so it never gets logged.
 */
const KEY = "portal-onboarding-token";

export function getOnboardingToken(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setOnboardingToken(token: string): void {
  try {
    sessionStorage.setItem(KEY, token);
  } catch {
    /* sessionStorage unavailable (private mode / blocked) — the guard handles it */
  }
}

export function clearOnboardingToken(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}

const STEP_KEY = "portal-onboarding-step";

export function getOnboardingStep(): number {
  try {
    const raw = sessionStorage.getItem(STEP_KEY);
    const n = raw == null ? NaN : Number.parseInt(raw, 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function setOnboardingStep(step: number): void {
  try {
    sessionStorage.setItem(STEP_KEY, String(step));
  } catch {
    /* no-op */
  }
}

export function clearOnboardingStep(): void {
  try {
    sessionStorage.removeItem(STEP_KEY);
  } catch {
    /* no-op */
  }
}
